<template>
  <div class="container">
    <div class="item">
      <img :src="logo" alt="" >
      <span>通知公告</span>
    </div>
    <vue-seamless-scroll :data="noticeList" :class-option="optionLeft" class="seamless-warp2" @click.native="parentClick">
      <ul class="items">
        <li class="li-s" v-for="item in noticeList" :key="item.article_id"><span :data-id="item.article_id">{{item.title}}</span></li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import logo from '@/assets/img/log1.png'
import axios from "axios";
import { orgId, requestUrl } from '../common/cons'
export default {
  name: "HomeTabs-right",
  data(){
    return{
      logo:logo,
      noticeList:[],
      flag:true
    }

  },
  computed: {
    optionLeft () {
      return {
        direction: 2,
        limitMoveNum: 3,
        hoverStop: true,
        step: 0.5
      }
    }
  },
  mounted() {
    this.getNoticeList()
  },
  methods:{
    async getNoticeList () {
      const { data } = await axios.get(`${requestUrl}/notice/${orgId}`)
      this.noticeList = data
    },
    tos(id){
      if(id){
        const routePath = this.$router.resolve({
          path: `/content/${id}`
        })
        window.open(routePath.href)
      }
    },
    parentClick(e){
      if (e.target.tagName == 'SPAN'){
        this.tos(e.target.dataset.id)
      }
    }
  }

}
</script>

<style scoped>
.container{
  width: 100%;
  height: 45px;
  background-color: white;
  display: flex;
  justify-content:flex-start;
  align-content: center;
}
.item{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 15px;
}
.item span{
  font-size: 20px;
  color: red;
}
.item  img{
  width: 25px; height: 25px;
}
.item{
  width: 200px;
  position: relative;
}
.seamless-warp2 {
  overflow: hidden;
  height: 100%;
  width: 100%;
  flex: 1;
}
.items {
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  height: 45px;
}
.items li:hover{
  cursor: pointer;
  color: #2574c2;
}
.items li {
  list-style-type: none;
  margin-right: 30px;
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/components/HomeTabs-right.vue